var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutCampaignSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 444,
    viewBox: "0 0 444 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413 222C413 188.248 404.056 155.099 387.079 125.927C370.102 96.7561 345.698 72.6044 316.352 55.9314C287.005 39.2583 253.765 30.6595 220.015 31.0103C186.265 31.3611 153.21 40.6491 124.217 57.9285C95.2235 75.2079 71.3267 99.8617 54.9597 129.38C38.5926 158.898 30.3397 192.226 31.0413 225.97C31.7429 259.715 41.3739 292.671 58.9537 321.483C76.5336 350.295 101.434 373.935 131.121 389.994L134.317 384.087C105.674 368.592 81.6488 345.784 64.6871 317.985C47.7255 290.186 38.4331 258.389 37.7562 225.831C37.0793 193.273 45.042 161.117 60.8335 132.637C76.6251 104.157 99.6815 80.3698 127.655 63.698C155.629 47.0262 187.521 38.0648 220.085 37.7263C252.648 37.3879 284.719 45.6843 313.034 61.7711C341.348 77.8578 364.894 101.16 381.274 129.306C397.654 157.451 406.284 189.435 406.284 222H413Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M347.228 405.308C387.094 378.074 416.995 338.585 432.398 292.827C447.802 247.069 447.869 197.538 432.588 151.739C417.308 105.94 387.513 66.3708 347.72 39.029C307.928 11.6872 260.306 -1.93675 212.074 0.222029L212.977 20.4078C256.82 18.4455 300.107 30.8294 336.278 55.6826C372.448 80.5358 399.531 116.503 413.421 158.134C427.311 199.764 427.25 244.788 413.249 286.381C399.247 327.973 372.068 363.868 335.83 388.624L347.228 405.308Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.654 272.603L284.455 214.801L291.526 221.872L225.189 288.209L221.654 291.745L218.118 288.209L151.781 221.872L158.852 214.801L216.654 272.603V152L226.654 152V272.603Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.5 185.5) rotate(126.979) scale(314.201 703.442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25F4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FDFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216 7.99997) rotate(131.158) scale(385.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2C55",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCampaignSpinner);
export default __webpack_public_path__ + "static/media/aboutCampaignSpinner.02fc3d95.svg";
export { ForwardRef as ReactComponent };